if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });

      window.addEventListener('resize', () => {
        window.requestAnimationFrame(() => this.stabilizeHeight());
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.stabilizeHeight());
      }
    }

    /*
      KAN-280: lock the slider's height to its tallest slide so autoplay rotation
      never changes the announcement bar's height (recurring mobile layout shift).
      Shorter messages stay vertically centered by the existing flex styles.
    */
    stabilizeHeight() {
      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length < 2) {
        return;
      }

      this.style.minHeight = '';
      let maxHeight = 0;
      slides.forEach(slide => {
        const content = slide.firstElementChild;
        maxHeight = Math.max(
          maxHeight,
          slide.getBoundingClientRect().height,
          content ? content.getBoundingClientRect().height : 0
        );
      });

      if (maxHeight > 0) {
        this.style.minHeight = `${maxHeight}px`;
      }
    }

    initSlider(swiperOptions) {

      /*
      // swiperOptions.disabledOnMobile = true;
      if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
        return;
      }

      // swiperOptions.disabledOnDesktop = true;
      if (swiperOptions.disabledOnDesktop && window.innerWidth > mobileWidth) {
        return;
      }
      */

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);
      this.stabilizeHeight();
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
